<template>
  <div class="teaching">
    <!--我的资源-->
    <main class="main">
      <div>
        <el-date-picker
          v-model="time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd  HH:mm:ss"
          @change="search">
        </el-date-picker>
      </div>
      <!--列表 与分页-->
      <div class="class_box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="name" label="姓名" width="120">
          </el-table-column>
          <!-- <el-table-column prop="nickname   " label="昵称" width="200">
          </el-table-column> -->
          <el-table-column prop="avatar" label="头像" width="100">
            <template slot-scope="scope">
              <img
                style="width: 30px; height: 30px; border-radius: 50%"
                :src="scope.row.avatar" />
            </template>
          </el-table-column>
          <el-table-column prop="type_name" label="类型" width="120">
          </el-table-column>
          <el-table-column prop="ip" label="ip" width="200"> </el-table-column>
          <el-table-column prop="route" label="路由"> </el-table-column>
          <el-table-column prop="method" label="请求方式" width="120">
          </el-table-column>
          <el-table-column prop="create_time" label="访问时间" width="200">
          </el-table-column>
        </el-table>
        <el-pagination
          background
          :page-size="page_size"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="handleCurrentChange"></el-pagination>
      </div>
    </main>
  </div>
</template>

<script>
import { logrest } from "@/api/task";
export default {
  data() {
    return {
      tableData: [],
      page_size: 10,
      total: 0,
      screen_teaching: "",
      time: [],
    };
  },
  created() {
    this.handleGetlogrest();
  },

  methods: {
    handleGetlogrest() {
      let data = {
        start_time: this.time ? this.time[0] : "",
        end_time: this.time ? this.time[1] : "",
      };
      logrest(data).then((res) => {
        this.tableData = res.data.data;
        this.total = res.data.total;
      });
    },
    search(v) {
      this.page = 1;
      this.handleGetlogrest();
    },
    handleCurrentChange(val) {
      this.handleGetlogrest();
    },
    handleCurrentChangeZY(val) {
      this.page = val;
      this.handleGetlogrest();
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  flex: 1;
  background-color: #fff;
  border-radius: 4px;
  padding: 35px 25px;
  box-sizing: border-box;
  width: 100%;
  min-height: 100%;
}
.class_box {
  padding-right: 35px;
}
.download_btn {
  color: #ff8ba0;
  margin-top: 15px;
}
/deep/.el-menu {
  background: #f2f7ff;
}
/deep/.el-menu.el-menu--horizontal {
  display: flex;
  border-bottom: solid 0px #fff;
}
.teaching {
  width: 1748px;
  height: 100%;
  background: #f2f7ff;
  position: relative;
  padding: 20px 40px 20px 20px;
  overflow: scroll;
  .el-select {
    position: absolute;
    right: 20px;
    top: 20px;
    /deep/.el-input__inner {
      border-radius: 10px;
    }
  }
  .search_user {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .search_left {
      position: relative;
      width: 272px;
      img {
        width: 40px;
        position: absolute;
        right: 0;
        top: 0;
      }
      .el-input {
        /deep/.el-input__inner {
          border-radius: 10px;
          background-color: #f2f3f5;
        }
      }
    }
    .el-button {
      background-color: #537af2;
    }
  }
  .shaixuan {
    margin-bottom: 15px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    padding-right: 50px;
    span {
      font-size: 16px;
      line-height: 20px;
    }
    .left {
      display: flex;
      align-items: baseline;
      .name {
        width: 100px;
      }
      .el-radio-group {
        width: 700px;
      }
      .el-radio {
        margin-bottom: 20px;
        // /deep/.el-radio__inner {
        //   border-radius: 0px;
        // }
      }
    }
  }
  main {
    padding-top: 20px;
    /deep/.see {
      color: #537af2;
    }
    /deep/.el-dialog {
      border-radius: 20px;
    }
    .el-pagination {
      // position: absolute;
      // bottom: 2%;
      // right: 53px;
      float: right !important;
      margin-top: 40px !important;
      padding-right: 50px !important;
    }
    .addclassbtn {
      // width: 178px;
      margin: auto;
      margin-top: 40px;
      cursor: pointer;
    }
    .upload_box {
      background: #f9fafe;
      padding: 20px;
      .upload_img {
        width: 90%;
        margin: auto;
      }
      .upload_btn {
        width: 178px;
        margin: auto;
        margin-top: 22px;
        cursor: pointer;
      }
    }
  }
  .progress_box {
    width: 100%;
    height: 197px;
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    padding-top: 40px;
    .el-progress {
      width: 70%;
      margin: auto;
    }
    p {
      font-size: 18px;
      color: #999999;
      margin-top: 20px;
      margin-bottom: 20px;
    }
  }
  .img_file {
    padding-bottom: 10px;
    display: block;
    width: 100%;
    min-height: 199px;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
    border: 1px dashed #999999;
    text-align: center;
    padding-top: 20px;
    position: relative;
    img {
      margin: auto;
      width: 79px;
      margin-bottom: 10px;
    }
  }
  .el-table {
    height: 65%;
    overflow-y: auto;
    .img_btn {
      width: 20px;
    }
  }
}
</style>
